import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { EMDMICONS } from '../../../../common/constants/icon-packs.constant';
import { CompatibilityGuidelinesService } from '../../service/compatibility-guidelines.service';
import { FileSaverService } from 'ngx-filesaver';
import { AttachmentService } from '../../../../common/service/attachment.service';
import { NotificationService } from "@progress/kendo-angular-notification";
import { CommonService } from '../../../../common/service/common.service';
import { HelpService } from '../../service/help.services';

@Component({
  selector: 'app-comp-guidelines',
  standalone: false,
  templateUrl: './comp-guidelines.component.html',
  styleUrl: './comp-guidelines.component.scss'
})


export class CompatibilityGuidelinesComponent {
  iconPacks = EMDMICONS;


  public myRestrictions: FileRestrictions = {
    allowedExtensions: ["jpg", "jpeg", "png"],
  };

  frmUploadItems: any;

  tagsList: any = [];
  selectedFile: any = null;
  fileName: string = 'Please choose a file.'
  compGuidelinesList: any = [];
  showButton: boolean = true;
  readonlyNote: boolean = true;
  validFileType: boolean = true;
  userId: any = sessionStorage.getItem('userId');

  constructor(
    private fb: FormBuilder,
    private compGuidelinesService: CompatibilityGuidelinesService,
    private fileSaverService: FileSaverService,
    private attachmentService: AttachmentService,
    private notificationService: NotificationService,
    private commonService:CommonService,
     private helpService: HelpService,
  ) { }

  ngOnInit() {
    this.bindFrmHelpItems();
    this.getCompatibilityGuidelines();
    this.userId = sessionStorage.getItem("userId") ?? 0;
  }

  onChangenote() {
   if(this.frmUploadItems.get('note')?.value!='')
      {
      this.showButton = false;
    }
      else{
      this.showButton = true;
    }
  }


  bindFrmHelpItems() {
    this.frmUploadItems = this.fb.group({
      file: [null],
      note: [{value:'',disabled: true}]
    });
  }

  triggerFileInput() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  resetForm() {
    this.readonlyNote = false;
    this.frmUploadItems.reset({
      file: null,
      note: {value:'',disabled: true}, // Keep field2 disabled

    });
    this.selectedFile = null;
    this.fileName = 'Please choose a file.'
  }

  onFileSelect(event: any) {
    this.validFileType = true;
    this.readonlyNote = false;
    this.frmUploadItems.get('note')?.enable();

    const file = event.target.files[0];
    var allowedExtensions = /(\.pdf)$/i;

    if (file) {
      this.fileName = file.name;
      if (!allowedExtensions.exec(this.fileName)) {
        this.validFileType = false;
      }
      this.selectedFile = file;
      this.frmUploadItems.patchValue({
        file: file
      });
    }

    if (event.target.files[0].name) {
      this.fileName = event.target.files[0].name
    }
  }


  onSubmit() {

    this.showButton = true;

    if (!this.validFileType) {
      this.commonService.showNotificationMessage('Please insert a file in pdf format.', 'error');
      this.resetForm();
    }

    if( this.compGuidelinesList.some((el: any) => el.fileName === this.fileName)) {
      this.commonService.showNotificationMessage('This file name already exists.', 'error');
      this.resetForm();
      return;
    }

    const formData = new FormData();
    formData.append('UserId', this.userId);
    formData.append('Notes', this.frmUploadItems.value.note);
    formData.append('File', this.selectedFile);

    this.compGuidelinesService.createCompatibilityGuidelines(formData).subscribe({
      next: (response: any) => {
        this.commonService.showNotificationMessage(this.selectedFile.name+' Successfully uploaded.','success','center', 200 , true, 60, 600);
        this.getCompatibilityGuidelines();
        this.resetForm();

      },
      error: (err: any) => {
        console.error('Error:', err);
      }
    })
  }

  getCompatibilityGuidelines() {
    this.compGuidelinesService.getCompatibilityGuidelines().subscribe({
      next: (response: any) => {
        this.compGuidelinesList = response;
      },
      error: (err: any) => {
      }
    })
  }

  addCompatibilityGuidelines() {
    let body = {}
    this.compGuidelinesService.createCompatibilityGuidelines(body).subscribe({
      next: (response: any) => {
        this.getCompatibilityGuidelines();
      },
      error: (err: any) => {
      }
    })
  }

  deleteCompatibilityGuidelines(useCompatibilityGuideId: number, fileName:string) {
    if (confirm('Do you want to delete this file?')) {
      this.compGuidelinesService.deleteCompatibilityGuidelines({ userId: this.userId, compatibilityGuideId: useCompatibilityGuideId })
        .subscribe({
          next: (response: any) => {
            this.commonService.showNotificationMessage(fileName+ ' was mark as deleted successfully!', 'success','center', 200 , true, 60, 600);
            this.getCompatibilityGuidelines();
          },
          error: (err: any) => {
          }
        })
    }
  }

  getAttachments(object: any) {
    this.helpService.downloadAttachments(object.blobURI).subscribe({
      next: (response: any) => {
        let fileName = object.fileName;
        if (response) {
          this.fileSaverService.save(response, fileName);
        }
      },
      error: (err: any) => {
      }
    })
  }
}


